export function fmtErrorAsString(err) {
    if (typeof err === 'string' || err instanceof String) {
        return err;
    } else if(Array.isArray(err.errors)) {
        const messages=[];
        err.errors.forEach( (error, i) => {
            if(error.message) {
                messages.push(error.message);
            }
        });
        return messages.join(": ");
    } else if(err) {
        return JSON.stringify(err);
    } else {
        return "";
    }
}


// const example_graphql_structed_err={
//     "data": {
//         "manageResource":null
//     },
//     "errors": [
//         {
//             "path": [
//                 "manageResource"
//             ],
//             "data":null,
//             "errorType":"Lambda:Unhandled",
//             "errorInfo":null,
//             "locations":[
//                 {
//                     "line":2,
//                     "column":3,
//                     "sourceName":null
//                 }
//             ],
//             "message":"'Start' command requires 'ResourceId' argument!"
//         }
//     ]
// };